export default __webpack_public_path__ + "static/hero-bg-video-3f81fc22f9a990bb0e3af3fb9ec72137.mp4";